import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			onError: (error) => {
				if (error.message) {
					console.error("Query error:", error.message);
				}
			},
		},
		mutations: {
			onError: (error) => {
				if (error.message) {
					console.error("Mutation error:", error.message);
				}
			},
		},
	},
});

export default queryClient;
